<script>
    import { navigate } from 'svelte-routing'
    import date from 'date-and-time'

    import { Functions } from '../../config/firebase'
    import { Projects } from '../../middleware/database/projects'
    import { currentUser } from '../../stores/current_user'

    import Form from './form.svelte'
    import { Spinner } from 'sveltestrap'

    export let id

    let saving = false
    let loading = true
    let project = {}

    const ensureFormFields = (project) => {
        const safeProject = {
            name: project.name || ''
        }
        return safeProject
    }

    $: if (loading) {
        Projects.findOne(id).then(doc => {
            project = ensureFormFields(doc)
            loading = false
        })
    }

    function updateHandler(event) {
        saving = true
        let delta = event.detail

        Projects.update(id, delta)
            .then(() => {
                saving = false
                navigate('/projects')
            })
            .catch(err => {
                alert('Could not update project!')
                console.log('Save Project:', err)
                saving = false
            })


    }
</script>

{#if !loading && !saving}
<Form pageTitle="Ret agent" {project} on:submit={updateHandler} />
{:else}
<Spinner size="lg" color="dark" type="grow" />
{/if}